/**
 * Форма слова при числе: «1 строка», «2 строки», «5 строк».
 *
 * Через `Intl.PluralRules`, а не через остатки от деления руками. Правило
 * русского языка сложнее, чем кажется по первым примерам: 11–14 идут по
 * форме «много» вопреки последней цифре, и написанное на глаз «11 строка»
 * потом ловится только случайно.
 */
const rules = new Intl.PluralRules('ru-RU');

export type PluralForms = readonly [one: string, few: string, many: string];

export function plural(count: number, forms: PluralForms): string {
  switch (rules.select(count)) {
    case 'one':
      return forms[0];
    case 'few':
      return forms[1];
    default:
      return forms[2];
  }
}

/** То же самое, но вместе с самим числом: «5 строк». */
export function pluralize(count: number, forms: PluralForms): string {
  return `${String(count)} ${plural(count, forms)}`;
}
